import React from 'react';
import { getPlaceholderPercentage } from 'base/utils/dom-size';
import { Link } from '@base/lib/Link';
import { LazyLoad } from '@base/lib/LazyLoad';
import cn from 'classnames';
import styles from './index.module.less';
import { isPhone } from 'base/utils/client';

type ILargeScreenContainerProps = Globals.BasicHTMLProps & {
    width: number;
    height: number;
    heightFixed?: boolean;
    largeScreenHeightFixed?: boolean;
    href?: string;
    bgColor?: string;
}

export const BannerPlaceholder: React.FC<ILargeScreenContainerProps> = props => {
    const {
        className,
        style,
        width = 1920,
        height = 700,
        heightFixed = false,
        largeScreenHeightFixed = false,
        href,
        bgColor,
        children,
        ...rest
    } = props;


    let commonProps = {} as React.HTMLProps<any>;
    if (heightFixed) {
        commonProps.className = cn(className, 'sw-placeholder', styles['height-fixed']);
        commonProps.style = {
            ...style,
            height,
            backgroundColor: bgColor || void 0,
        }
    } else if (!isPhone && largeScreenHeightFixed) {
        commonProps.className = cn(className, 'sw-placeholder', styles['large-limit']);
        commonProps.style = {
            ...style,
            paddingBottom: getPlaceholderPercentage(width, height),
            height,
            backgroundColor: bgColor || void 0,
        }
    } else {
        commonProps.className = cn(className, 'sw-placeholder');
        commonProps.style = {
            ...style,
            paddingBottom: getPlaceholderPercentage(width, height),
            backgroundColor: bgColor || void 0
        }
    }

    return (
        <Link
            href={href}
            hrefEmptyTag={'div'}
            {...commonProps}
            {...rest}
        >
            <LazyLoad className={'sw-overlay'}>
                {children}
            </LazyLoad>
        </Link>
    )
}
